import { render, staticRenderFns } from "./DataHistory.vue?vue&type=template&id=f040b8c0&scoped=true&lang=pug"
import script from "./DataHistory.vue?vue&type=script&lang=ts"
export * from "./DataHistory.vue?vue&type=script&lang=ts"
import style0 from "./DataHistory.vue?vue&type=style&index=0&id=f040b8c0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f040b8c0",
  null
  
)

/* custom blocks */
import block0 from "./DataHistory.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FDataHistory%2FDataHistory.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports